import {
  callApexRest
} from '../library/aws'

import {
  UPDATE_USER_ATTRIBUTES
} from './../stores/auth'

import {
  paginateItems,
  sortItems
} from '../library/general'

const UPDATE = 'invoices/UPDATE'
const UPDATE_SORT = 'invoices/UPDATE_SORT'

export const BILLING_DATE_COLUMN = 'billingDate'
export const DUE_DATE_COLUMN = 'dueDate'
export const NAME_COLUMN = 'name'
export const TOTAL_COLUMN = 'total'
export const BALANCE_COLUMN = 'balance'
export const RECEIVED_AMOUNT_COLUMN = 'receivedAmount'
export const CREDIT_APPLIED_AMOUNT_COLUMN = 'creditApplied'
export const PAYMENT_TERMS_COLUMN = 'paymentTerms'
export const TYPE_COLUMN = 'type'
export const BILLING_DATE_COLUMN_FRIENDLY = 'Billed'
export const DUE_DATE_COLUMN_FRIENDLY = 'Due'
export const NAME_COLUMN_FRIENDLY = 'Reference #'
export const TOTAL_COLUMN_FRIENDLY = 'Total'
export const BALANCE_COLUMN_FRIENDLY = 'Balance'
export const RECEIVED_AMOUNT_COLUMN_FRIENDLY = 'Received'
export const CREDIT_APPLIED_AMOUNT_COLUMN_FRIENDLY = 'Credit'
export const PAYMENT_TERMS_COLUMN_FRIENDLY = 'Terms'
export const TYPE_COLUMN_FRIENDLY = 'Type'

const initialState = {
  invoices: [],
  fetched: false,
  loading: false,
  error: '',
  hasError: false,
  subsetInvoices: [],
  pageNumber: 1,
  pageSize: 12,
  totalSubsetInvoices: 0,
  totalBalanceDue: 0,
  numberOfPages: 0,
  sortColumn: BILLING_DATE_COLUMN,
  sortDirection: {
    [BILLING_DATE_COLUMN]: 'desc'
  }
}

const handler = (state = initialState, action) => {
  const {payload} = action

  switch (action.type) {
    case UPDATE:
      return {
        ...state,
        ...payload
      }

    case UPDATE_SORT:
      return {
        ...state,
        sortColumn: payload.sortColumn,
        sortDirection: {
          ...payload.sortDirection
        }
      }

    default:
      return state
  }
}

export const requestInvoices = () => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE,
      payload: {
        loading: true,
        hasError: false,
        error: ''
      }
    })

    try {
      const {
        sortColumn,
        sortDirection,
        pageSize,
        pageNumber
      } = getState().stores.invoices

      const data = await callApexRest('INVOICES', null, null)

      const {
        invoices,
        contactFullName,
        contactEmailAddress,
        primaryAccountName,
        primaryPostOpsAccountManagerName,
        primaryPostOpsAccountManagerEmail,
        primaryPostOpsAccountManagerPhone,
        primaryLiveOpsAccountManagerName,
        primaryLiveOpsAccountManagerEmail,
        primaryLiveOpsAccountManagerPhone,
        primaryAccountSalesEngineerName,
        primaryAccountSalesEngineerEmail,
        primaryAccountSalesEngineerPhone,
        showInvoicesTab
      } = data

      dispatch({
        type: UPDATE_USER_ATTRIBUTES,
        payload: {
          contactName: contactFullName,
          contactEmail: contactEmailAddress,
          accountName: primaryAccountName,
          primaryPostOpsAccountManagerName,
          primaryPostOpsAccountManagerEmail,
          primaryPostOpsAccountManagerPhone,
          primaryLiveOpsAccountManagerName,
          primaryLiveOpsAccountManagerEmail,
          primaryLiveOpsAccountManagerPhone,
          primaryAccountSalesEngineerName,
          primaryAccountSalesEngineerEmail,
          primaryAccountSalesEngineerPhone,
          showInvoicesTab
        }
      })

      const subsetInvoicesBeforePagination = sortItems(invoices, sortColumn, sortDirection[sortColumn])

      const totalSubsetInvoices = subsetInvoicesBeforePagination.length
      const numberOfPages = Math.ceil(totalSubsetInvoices / pageSize)

      subsetInvoicesBeforePagination.forEach((f, i) => f['#'] = i + 1)

      const subsetInvoices = paginateItems(subsetInvoicesBeforePagination, pageNumber, pageSize)
      subsetInvoices.forEach((f, i) => f['#'] = i + 1)

      let totalBalanceDue = 0

      subsetInvoices.forEach(f => {
        if (f[BALANCE_COLUMN] > 0)
          totalBalanceDue += f[BALANCE_COLUMN]
      })

      dispatch({
        type: UPDATE,
        payload: {
          fetched: true,
          invoices,
          subsetInvoices,
          numberOfPages,
          totalSubsetInvoices,
          totalBalanceDue
        }
      })
    }
    catch (e) {
      dispatch({
        type: UPDATE,
        payload: {
          error: e.message,
          hasError: true
        }
      })
    }

    dispatch({
      type: UPDATE,
      payload: {
        loading: false
      }
    })
  }
}

export const requestSortInvoices = (sortColumn, sortDirection) => {
  return async(dispatch, getState) => {
    const {
      invoices,
      pageNumber,
      pageSize
    } = getState().stores.invoices

    // sorting
    // pagination
    // Return subsetInvoices

    const subsetInvoicesBeforePagination = sortItems(invoices, sortColumn, sortDirection)

    const totalSubsetInvoices = subsetInvoicesBeforePagination.length
    const numberOfPages = Math.ceil(totalSubsetInvoices / pageSize)

    subsetInvoicesBeforePagination.forEach((f, i) => f['#'] = i + 1)

    const subsetInvoices = paginateItems(subsetInvoicesBeforePagination, pageNumber, pageSize)
    subsetInvoices.forEach((f, i) => f['#'] = i + 1)

    dispatch({
      type: UPDATE_SORT,
      payload: {
        sortColumn,
        sortDirection: {
          [sortColumn]: sortDirection
        }
      }
    })

    dispatch({
      type: UPDATE,
      payload: {
        subsetInvoices,
        numberOfPages,
        totalSubsetInvoices,
        pageNumber: 1
      }
    })
  }
}

export const requestPageStep = nextPageNumber => {
  return async(dispatch, getState) => {
    const {
      invoices,
      pageSize,
      numberOfPages,
      sortColumn,
      sortDirection
    } = getState().stores.invoices

    if (nextPageNumber <= numberOfPages && nextPageNumber > 0) {
      dispatch({
        type: UPDATE,
        payload: {
          pageNumber: nextPageNumber
        }
      })

      const subsetInvoicesBeforePagination = sortItems(invoices, sortColumn, sortDirection[sortColumn])
      const totalSubsetInvoices = subsetInvoicesBeforePagination.length
      const numberOfPages = Math.ceil(totalSubsetInvoices / pageSize)

      subsetInvoicesBeforePagination.forEach((f, i) => f['#'] = i + 1)

      const subsetInvoices = paginateItems(subsetInvoicesBeforePagination, nextPageNumber, pageSize)

      dispatch({
        type: UPDATE,
        payload: {
          loading: false,
          subsetInvoices,
          numberOfPages,
          totalSubsetInvoices
        }
      })
    }
  }
}

export const requestInvoiceDownload = id => {
  return async(dispatch, getState) => {
    dispatch({
      type: UPDATE,
      payload: {
        loading: true,
        hasError: false,
        error: ''
      }
    })

    try {
      const data = await callApexRest('INVOICE', null, id)

      const downloadLink = document.createElement('a')

      let contentType = 'application/pdf' // default

      if(data.extension === 'docx') {
        contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      }

      if(data.extension === 'xlsx') {
        contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }

      downloadLink.href = `data:${contentType};base64,` + data.content
      downloadLink.download = data.name + '.' + data.extension

      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    }
    catch (e) {
      dispatch({
        type: UPDATE,
        payload: {
          error: e.message,
          hasError: true
        }
      })
    }

    dispatch({
      type: UPDATE,
      payload: {
        loading: false
      }
    })
  }
}

export default handler